import React from 'react';

const ArrowRight = ({ className }) => (
  <svg
    className={className}
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.41955 0L14.4947 5.07519V6.49624L9.41955 11.5714L7.97819 10.1504L11.3075 6.80075H0V4.77068H11.3075L7.95789 1.42105L9.41955 0Z"
      fill="white"
    />
  </svg>
);

export default ArrowRight;
